{
  "name": "products.novi.web",
  "version": "4.88.2",
  "engines": {
    "node": ">=20.19.0"
  },
  "scripts": {
    "start:web": "ng serve web-app",
    "start:web:ssl": "ng serve web-app --port=443 --ssl",
    "start:native": "ng serve native-app",
    "start:poker": "ng serve casino-poker-app",
    "start:proxy": "node ./tools/dev-proxy/main.js",
    "build": "ng build",
    "ng:run": "ng run",
    "build:web:github": "ng run web-app:build:production && ng run web-app:server:production",
    "build:native:github": "ng run native-app:build:production && ng run native-app:server:production",
    "build:poker:github": "ng run casino-poker-app:build:production && ng run casino-poker-app:server:production",
    "test:native:github": "ng test --project=native-app --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:native": "ng test --project=native-app --code-coverage",
    "test:poker:github": "ng test --project=casino-poker-app --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:poker": "ng test --project=casino-poker-app --code-coverage",
    "test:web:github": "ng test --project=unit-test-app --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:web:github:detailed": "set KARMA_DETAILED=true&& ng test --project=unit-test-app --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:web": "ng test --project=unit-test-app --code-coverage",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:styles": "stylelint **/*.scss",
    "lint:styles:fix": "stylelint **/*.scss --fix",
    "release": "standard-version",
    "release:patch": "npm run release -- --release-as patch",
    "release:minor": "npm run release -- --release-as minor",
    "release:major": "npm run release -- --release-as major",
    "release:draft": "npm run release -- --prerelease",
    "sprite-generator": "node ./tools/sprite-generator/generate.js",
    "bundle:report": "source-map-explorer dist/web-app/**/*.js",
    "generate-icons": "svg-to-ts-files",
    "generate-icons-preview": "node ./projects/@shared/assets/icons/build/build",
    "mocks": "mocks-server",
    "generate:octo:vars": "node ./tools/octopus_variables/generate-octopus-variables.mjs",
    "deploy:octo": "node ./tools/automatedOCBuild.js",
    "storybook": "ng run web-app:storybook",
    "build-storybook": "ng run web-app:build-storybook"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.14",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.14",
    "@angular/compiler": "^20.3.14",
    "@angular/core": "^20.3.14",
    "@angular/elements": "^20.3.14",
    "@angular/forms": "^20.3.14",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.14",
    "@angular/platform-browser-dynamic": "^20.3.14",
    "@angular/platform-server": "^20.3.14",
    "@angular/router": "^20.3.14",
    "@angular/ssr": "^20.3.12",
    "@esotericsoftware/spine-pixi-v8": "^4.2.95",
    "@fullstory/browser": "^1.7.1",
    "@microsoft/signalr": "^8.0.7",
    "@ngx-translate/core": "^17.0.0",
    "@ngxs/logger-plugin": "^20.1.0",
    "@ngxs/storage-plugin": "^20.1.0",
    "@ngxs/store": "^20.1.0",
    "@pixi/sound": "^6.0.1",
    "@revolut/checkout": "^1.1.24",
    "@sentry/angular": "^10.27.0",
    "@transifex/api": "^7.1.3",
    "axios": "^1.7.9",
    "chart.js": "^4.4.7",
    "compression": "^1.7.5",
    "express": "^4.21.2",
    "firebase": "^11.1.0",
    "gsap": "2.1.3",
    "html-to-image": "^1.11.11",
    "http-proxy-middleware": "^3.0.5",
    "idpay-b2b-sdk": "^2.1.0",
    "ng2-charts": "^4.1.1",
    "ngx-infinite-scroll": "^20.0.0",
    "ngx-sharebuttons": "^17.0.0",
    "pixi.js": "^8.14.3",
    "prerender-node": "^3.8.3",
    "prom-client": "^15.1.3",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.1",
    "swiper": "^11.2.0",
    "tslib": "2.8.1",
    "winston": "^3.17.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.12",
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/cli": "^20.3.12",
    "@angular/compiler-cli": "^20.3.14",
    "@chromatic-com/storybook": "^4.1.3",
    "@compodoc/compodoc": "^1.1.32",
    "@mocks-server/main": "^4.1.0",
    "@ngxs/devtools-plugin": "^20.1.0",
    "@octopusdeploy/api-client": "^3.0.6",
    "@storybook/addon-docs": "^9.1.16",
    "@storybook/addon-links": "^9.1.16",
    "@storybook/addon-onboarding": "^9.1.16",
    "@storybook/angular": "^9.1.16",
    "@types/compression": "^1.7.5",
    "@types/express": "^4.17.25",
    "@types/file-saver-es": "2.0.1",
    "@types/jasmine": "5.1.0",
    "@types/jasminewd2": "2.0.10",
    "@types/jquery": "3.5.14",
    "@types/node": "^20.19.0",
    "@types/qrcode": "^1.5.5",
    "@typescript-eslint/eslint-plugin": "^8.39.0",
    "@typescript-eslint/parser": "^8.39.0",
    "baseline-browser-mapping": "^2.9.19",
    "browser-sync": "^3.0.2",
    "browserslist": "^4.28.0",
    "eslint": "9.8.0",
    "eslint-plugin-storybook": "^9.1.16",
    "eslint-plugin-unused-imports": "^4.1.4",
    "fs-extra": "^11.1.1",
    "jasmine-core": "5.5.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.0",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "^2.2.0",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "karma-teamcity-reporter": "^1.1.0",
    "karma-spec-reporter": "^0.0.36",
    "prettier": "3.5.3",
    "source-map-explorer": "2.5.3",
    "source-map-support": "0.5.21",
    "standard-version": "9.5.0",
    "storybook": "^9.1.16",
    "stylelint": "^16.26.0",
    "stylelint-config-standard": "^39.0.1",
    "stylelint-config-standard-scss": "^16.0.0",
    "stylelint-scss": "^6.12.1",
    "tinify": "1.7.1",
    "typescript": "~5.9.3"
  }
}
